import { classNames } from '@/utils/classNames';

import Icon from '@/components/base/Icon';

type SparksActionButtonProps = {
    label: string;
    onClick: () => void;
};

export function SparksActionButton({ label, onClick }: SparksActionButtonProps) {
    return (
        <button
            type="button"
            onClick={onClick}
            className={classNames(
                'flex w-fit items-center gap-1.5 rounded-full px-1.5 py-1.5',
                'bg-white font-GMedium text-xs tracking-tight text-icoBlack',
                'transition-colors hover:bg-icoGray-300'
            )}>
            <span className="leading-[14px]">{label}</span>
            <Icon icon="chevron-right" className="text-[14px] text-icoGray-500" />
        </button>
    );
}
